module.exports = __webpack_public_path__ + "img/pixelambacht.a6bf5326.svg";